(function() {
    'use strict';
    var MessageDisplayBaseCtrl = function MessageDisplayBaseCtrl(autoInit) {
        return function MessageDisplayBase($scope, $sce, $stateParams, PatientPortalStorageRepository, TransitionManager, MyMessagesRepository, MyMessagesService, MyChartService, gettext) {
            $scope.loading = false;

            var displayReceiveMessages = $stateParams.displayMode.toUpperCase() === 'RECEIVED';

            $scope.displaySentMessages = false;
            $scope.thumbnailSrc = MyChartService.getMaleThumbnailSrc(50,50);

            $scope.displayMessages = {
                Messages: null,
                NumberOfMessages: 0
            };
            
            $scope.displayMessageThreadRoute = 'myMessagesDisplayMessageThread';

            $scope.messageFilter = {
                MessageSubTypeId: '00000000-0000-0000-0000-000000000000',
                SearchSendReceivedMessages: '',
                SortDirection: 'desc',
                NumberOfMessages: 250,
                SearchNewOldMessages: 'Both'
            };

            var activePatient = PatientPortalStorageRepository.getActivePatient();

            function getMessageSettings() {
                return MyMessagesService.getMessageSettings(activePatient.id)
                    .then(function (data) {
                        var msgSubTypes;
                        var defaultSettings = data[0];

                        if (displayReceiveMessages) {
                            msgSubTypes = _(defaultSettings.MessageSubTypes)
                                .filter({ 'Enabled' : true, 'CanBeReceivedByPatient' : true })
                                .value();
                        } else {
                            msgSubTypes = _(defaultSettings.MessageSubTypes)
                                .filter({ 'Enabled' : true, 'CanBeSentByPatient' : true, 'SystemMessage': false })
                                .value();
                        }

                        msgSubTypes.push(
                            {
                                Enabled: true,
                                Id: '00000000-0000-0000-0000-000000000000',
                                Name: gettext('All Messages'),
                                SystemMessage: false
                            });

                        $scope.messageSubTypes = msgSubTypes;
                        $scope.selectedMessageSubTypeName = 'All Messages';
                    })
                    .catch(function (response) {
                        $scope.addHttpError(response, '', 'listData');
                    });
            }

            $scope.getMessages = function(messageFilter) {
                if ($scope.messageFilter.SearchSendReceivedMessages.toUpperCase() === 'UNKNOWN') {
                    return;
                }

                $scope.loading = true;
                $scope.removeHttpError();
                MyMessagesRepository
                    .getMessages(activePatient.id, messageFilter)
                    .then(function (data) {
                        $scope.displayMessages.Messages = _(data)
                            .forEach(function (msg) {
                                msg.MessageHeaderText = MyMessagesService.cleanMessageHeader(msg.MessageHeaderText);
                                msg.MessageBodyText = $sce.trustAsHtml(MyMessagesService.removeLineBreaks(msg.MessageBodyText));

                                if ($scope.messageFilter.SearchSendReceivedMessages.toUpperCase() === 'RECEIVED') {
                                    if (msg.LastReadByPortalDate == null) {
                                        msg.NewMessage = true;
                                    }
                                    else {
                                        msg.NewMessage = false;
                                    }
                                }
                            });
                        $scope.displayMessages.NumberOfMessages = $scope.displayMessages.Messages.length;
                    })
                    .catch(function (response) {
                        $scope.addHttpError(response);
                    })
                    .finally(function () {
                        $scope.loading = false;
                    });
            };
            
            function initialize() {
                if ($stateParams.displayMode.toUpperCase() === 'RECEIVED') {
                    $scope.panelHeadingText = gettext('Inbox'); //gettext('Received Messages');
                    $scope.messageFilter.SearchSendReceivedMessages = 'Received';
                    $scope.displaySentMessages = false;
                }
                else if ($stateParams.displayMode.toUpperCase() === 'SEND') {
                    $scope.panelHeadingText = gettext('Sent Messages');
                    $scope.messageFilter.SearchSendReceivedMessages = 'Send';
                    $scope.displaySentMessages = true;
                }
                else {
                    $scope.panelHeadingTest = 'Unknown display mode - ' + $stateParams.displayMode;
                    $scope.messageFilter.SearchSendReceivedMessages = 'Unknown';
                    $scope.displaySentMessages = false;
                }
                $scope.getMessages($scope.messageFilter);
            }

            $scope.filterMessages = function filterMessages(id) {
                $scope.loading = true;

                var selectedItem = _.find($scope.messageSubTypes, {Id: id});
                $scope.selectedMessageSubTypeName = selectedItem.Name;     //$scope.messageSubTypes[Index].Name;
                $scope.messageFilter.MessageSubTypeId = selectedItem.Id;   //$scope.messageSubTypes[Index].Id;
                $scope.messageFilter.SortDirection = 'desc';

                $scope.getMessages($scope.messageFilter);
            };

            $scope.displayMessageThread = function displayMessageThread(message) {
                if ($scope.messageFilter.SearchSendReceivedMessages.toUpperCase() === 'RECEIVED') {
                    TransitionManager.transition({appRoute: $scope.displayMessageThreadRoute, opts: {displayMode: 'received', id: message.MessageId, updateNotification: message.NewMessage}});
                }
                else {
                    TransitionManager.transition({appRoute: $scope.displayMessageThreadRoute, opts: {displayMode: 'send', id: message.MessageId}});
                }
            };

            $scope.onLoad = function() {
                getMessageSettings();

                if(autoInit)
                    initialize();
            };
            
            $scope.onLoad();
        };
    };
    var DisplayMessagesCtrl = new MessageDisplayBaseCtrl(true);
    var MyMessagesMobileCtrl = function ($scope, $sce, $stateParams, PatientPortalStorageRepository, TransitionManager, MyMessagesRepository, MyMessagesService, MyChartService, gettext, _, $state, ContentAttributeService) {
        new MessageDisplayBaseCtrl(false).call(this, $scope, $sce, $stateParams, PatientPortalStorageRepository, TransitionManager, MyMessagesRepository, MyMessagesService, MyChartService, gettext);
        $scope.isInSubstate = function isInSubState() {
            return !$state.is('myMessagesMobile');
        };
        $scope.displayMessageThreadRoute = 'myMessagesMobileDisplayMessageThread';
        $scope.folders = [
              {
                  Key: 'inbox',
                  Name: 'Inbox',
                  Filter: 'Received'
              },
              {
                  Key: 'outbox',
                  Name: 'Sent',
                  Filter: 'Send'
              }
        ];
        $scope.selectedFolder = undefined;

        $scope.mobileModel = {
            subMessageText: ''
        };

        ContentAttributeService.getMessageSubHeading(false)
            .then(function(data) {
                $scope.mobileModel.subMessageText = data;
            })
            .catch(function () {
                $scope.mobileModel.subMessageText = '';
            });

        $scope.changeFolder = function changeFolder(folderKey) {
            $scope.selectedFolder = _.find($scope.folders, { Key: folderKey || $stateParams.folder }) || $scope.selectedFolder || $scope.folders[0];
            $scope.messageFilter.SearchSendReceivedMessages = $scope.selectedFolder.Filter;
            $scope.getMessages($scope.messageFilter);
        };
        $scope.composeNewMessage = function composeNewMessage() {
            $scope.inSubState = true;
            TransitionManager.transition({ appRoute: 'myMessagesMobileNewMessage' });  
        };
        
        $scope.displayMessageThreadMobile = function displayMessageThreadMobile(message) {
            $scope.inSubState = true;
            $scope.displayMessageThread(message);  
        };
        
        $scope.goBackToMessages = function goBackToMessages() {
            $scope.inSubState = false;
            TransitionManager.transition({ appRoute: 'myMessagesMobile' });  
        };
    };
    angular.module('mymessages').controller('DisplayMessagesCtrl',
        ['$scope', '$sce', '$stateParams', 'PatientPortalStorageRepository', 'TransitionManager', 'MyMessagesRepository', 'MyMessagesService', 'MyChartService', 'aprgettext',
            DisplayMessagesCtrl]);
    angular.module('mymessages').controller('MyMessagesMobileCtrl',
        ['$scope', '$sce', '$stateParams', 'PatientPortalStorageRepository', 'TransitionManager', 'MyMessagesRepository', 'MyMessagesService', 'MyChartService', 'aprgettext', '_', '$state', 'ContentAttributeService',
            MyMessagesMobileCtrl]);
})();